<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Tareas</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/tareas/nuevo">Nueva</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <b-table v-else hover v-bind:items="tasks" v-bind:fields="headers" outlined
                     head-variant="light">
                <template slot="id" slot-scope="data">
                    <b-link v-bind:to="'/tareas/' + data.item.id">{{data.item.id}}</b-link>
                </template>
                <template slot="stage" slot-scope="data">
                    <b-link v-bind:to="'/etapas/' + data.item.stage.value">{{data.item.stage.label}}</b-link>
                </template>
                <template slot="finished" slot-scope="data">
                    <span v-html="(data.item.finished === true ) ? 'Finalizado' : 'En progreso'"></span>
                </template>
                <template slot="finish_date" slot-scope="data">
                    <span>{{data.item.finish_date | moment("DD/MM/YYYY")}}</span>
                </template>
                <template slot="actions" slot-scope="data">
                    <div class="btn-group">
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/tareas/' + data.item.id">Ver</b-button>
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/tareas/editar/' + data.item.id">Editar</b-button>
                    </div>
                </template>

            </b-table>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "Tasks",
        data() {
            return {
                isLoading: true,
                headers: [
                    {key: 'id', label: 'ID', sortable: true},
                    {key: 'title', label: 'Título', sortable: true},
                    {key: 'stage', label: 'Etapa', sortable: true},
                    {key: 'finished', label: 'Estado', sortable: true},
                    {key: 'finish_date', label: 'Fecha de finalización', sortable: true},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ]
            }
        },
        computed: {
            ...mapGetters({
                tasks: 'tasks/getEntries'
            })
        },
        created() {
            this.isLoading = true;
            this.$store.dispatch('tasks/loadEntries').then(() => {
                this.isLoading = false;
            });
        }
    }
</script>

